import { create } from 'zustand';
import type { AskAiHistoryTurn, AskAiTurn } from '@/types/askAi';

interface AskAiState {
  isOpen: boolean;
  turns: AskAiTurn[];
  history: AskAiHistoryTurn[];
  /**
   * A question queued from outside the panel (guided-tour chips). The sheet
   * consumes it on mount/open and sends it, so the caller never has to reach
   * into the sheet's local input state.
   */
  pendingQuestion: string | null;

  open: () => void;
  close: () => void;
  toggle: () => void;
  /** Open the panel and queue `question` for immediate submission. */
  ask: (question: string) => void;
  clearPendingQuestion: () => void;
  appendTurn: (turn: AskAiTurn) => void;
  pushHistory: (turn: AskAiHistoryTurn) => void;
  clearConversation: () => void;
}

export const useAskAiStore = create<AskAiState>((set) => ({
  isOpen: false,
  turns: [],
  history: [],
  pendingQuestion: null,

  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  toggle: () => set((s) => ({ isOpen: !s.isOpen })),

  ask: (question) => set({ isOpen: true, pendingQuestion: question }),
  clearPendingQuestion: () => set({ pendingQuestion: null }),

  appendTurn: (turn) => set((s) => ({ turns: [...s.turns, turn] })),
  pushHistory: (turn) => set((s) => ({ history: [...s.history, turn] })),
  clearConversation: () => set({ turns: [], history: [] }),
}));
